import { profile, axiosConfig } from 'api';

import { CostCenter } from 'models/costCenter';
import { Response } from 'models/response';

export const getCostCenters = async (): Promise<CostCenter[]> => {
  try {
    const response = await profile.get<Response<CostCenter[]>>('/CostCenter/GetAllCostCenter', axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveCostCenter = async (costCenter): Promise<CostCenter> => {
  try {
    const response = costCenter.id
      ? await profile.put<Response<CostCenter>>(`/costCenter/${costCenter.id}`, {
          ...costCenter,
          budget: costCenter.budget === 'undefined' ? '0' : `${costCenter.budget}` ?? '0',
        })
      : await profile.post<Response<CostCenter>>('/costCenter', {
          ...costCenter,
          budget: costCenter.budget === 'undefined' ? '0' : `${costCenter.budget}` ?? '0',
          isActive: true,
        });
    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};
